const VipType = {
  Consumer: "consumer",
  Rides: "rides",
  Biz: "biz",
  Public: "public",
  BizPlus: "biz-plus",
  BizMax: "biz-max",
};

export default VipType;
